import { render, staticRenderFns } from "./AtualizacaoManual.vue?vue&type=template&id=d3bd81a8&"
import script from "./AtualizacaoManual.vue?vue&type=script&lang=js&"
export * from "./AtualizacaoManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports